const { getElement } = window.BAO.Utils

class HeaderSearchInput extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.speed) return

    this.interval = this.setupIdeas()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    clearInterval(this.interval)
  }

  setupListeners () {
    super.setupListeners()

    if (this.openSearch) {
      this.listeners.add(
        this.els.input.element,
        'click',
        this.handleClick.bind(this),
      )
    }
  }

  setupIdeas () {
    let index = 0

    return setInterval(() => {
      index += 1

      if (index + 1 > this.ideas.length) {
        index = 0
      }

      const idea = this.ideas[index]

      this.els.input.element.setAttribute(
        'placeholder',
        `${this.string} ${idea}`,
      )
    }, this.speed)
  }

  handleClick () {
    if (window.drawers?.activeDrawerKey === 'search') return
    this.drawers = getElement('site-drawers')
    this.drawers.open('search')
  }

  get ideas () {
    return this.dataset.ideas.split(',').map((idea) => idea.trim())
  }

  get openSearch () {
    return this.dataset.openSearch === 'true'
  }

  get speed () {
    return Number(this.dataset.speed) * 1000
  }

  get string () {
    return this.dataset.string
  }
}

if (!customElements.get('header-search-input')) {
  customElements.define('header-search-input', HeaderSearchInput)
}
